import styled from "styled-components"
import "typeface-lora"

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-right: 50px;
  color: #222222;
`

export const HomeGrid = styled.div`
  display: grid;
  grid-template-columns: 95px 1.35fr 0.65fr;
`
